// extracted by mini-css-extract-plugin
export var numberInputContainer = "_8a-0";
export var startPickingButton = "_8a-1";